import type { UserPermissionsMap } from '@unifyapps/carbon/no-code/access-control/types';
import type { UseFetchInterfaceAppResourcesHookType } from '../../types';

const useCachedInterfaceAppResources: UseFetchInterfaceAppResourcesHookType = () => {
  return {
    isLoading: false,
    error: undefined,
    interfaceRecord: undefined,
    permissions: {} as UserPermissionsMap,
    envVariables: {},
    commonNamespace: undefined,
    dataSources: undefined,
    globalInterfacePage: undefined,
  };
};

export default useCachedInterfaceAppResources;
